jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.accordions').length ) {
        let $ = jQuery;

        $('.accordion .accordion-header').on('click', function () {
            $accordionBody = $(this).parent('.accordion').find('.accordion-content');
            $toggleIcon = $(this).children('.toggle-icon');
            $(this).toggleClass('open');
            $toggleIcon.toggleClass('open');
            $accordionBody.toggleClass('open').slideToggle();
        });

    }
});